import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { request } from "@/js/http/http_request";
import { stockTypes, orderStatus } from "@/js/lists.ts";
import { getFullNameUser } from "@/js/user/user";
export default {
  props: {
    value: Boolean,
    idStock: Number
  },
  data: function data() {
    return {
      loaded: false,
      stock: {},
      headers: [{
        text: "Order",
        value: "order.reference_order",
        align: "center"
      }, {
        text: "Customer",
        value: "order.user.full_name",
        align: "center"
      }, {
        text: "Qty",
        value: "quantity",
        align: "center"
      }, {
        text: "Order date",
        value: "order.date_order",
        align: "center"
      }, {
        text: "Status",
        value: "order.status",
        align: "center"
      }, {
        text: "",
        value: "actions",
        align: "center"
      }],
      items: [],
      stockTypes: stockTypes,
      orderStatus: orderStatus
    };
  },
  computed: {
    shown: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit("input", value);
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.idStock) {
              _this2.getDatas();
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    idStock: {
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(newVal, oldVal) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (newVal) {
                  this.loaded = false;
                  this.getDatas();
                } else {
                  this.loaded = false;
                }
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function handler(_x, _x2) {
          return _handler.apply(this, arguments);
        }
        return handler;
      }()
    }
  },
  methods: {
    getDatas: function getDatas() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Promise.all([_this3.fetchStock(), _this3.fetchCommittedStocks()]);
            case 2:
              _this3.loaded = true;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchStock: function fetchStock() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, url, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this4;
              url = "/v1/stock/" + _this4.idStock;
              _context4.next = 4;
              return request(url, "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load committed stock.", {
                  type: "error"
                });
                throw e;
              });
            case 4:
              response = _context4.sent;
              _this4.stock = response.data;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchCommittedStocks: function fetchCommittedStocks() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, url, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this5;
              url = "/v1/stocks/" + _this5.idStock + "/committed";
              _context5.next = 4;
              return request(url, "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load committed stocks.", {
                  type: "error"
                });
                throw e;
              });
            case 4:
              response = _context5.sent;
              _this5.items = response.data ? response.data.reduce(function (acc, x) {
                var key = x.order.id_order;
                if (acc.some(function (y) {
                  return y.order.id_order === key;
                })) {
                  acc.find(function (y) {
                    return y.order.id_order === key;
                  }).quantity += x.quantity;
                } else {
                  acc.push(x);
                }
                return acc;
              }, []) : [];
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    orderRoute: function orderRoute(idOrder) {
      return {
        name: "adminOrderSummary",
        params: {
          id: idOrder
        }
      };
    },
    close: function close() {
      this.$emit("close");
    },
    getFullNameUser: getFullNameUser
  }
};